import vue from "vue";

const state = {
  activeNodes: {},
  calculationSchemes: {},
  settings: {}
};

const mutations = {
  SET_MODELLING_ACTIVE_NODES(state, nodes) {
    vue.set(state, "activeNodes", nodes);
  },
  SET_CALCULATION_SCHEMES(state, schemes) {
    vue.set(state, "calculationSchemes", schemes);
  },
  SET_MODELLING_SETTINGS(state, settings) {
    vue.set(state, "settings", settings);
  }
};

export default {
  state,
  mutations
};
